import { SnackbarApiErrorMessage } from '@ui-framework/index';

const fetchEmail = async params => {
  const response = await params?.get(params?.fetchEmail);
  if (response?.ok) {
    return response.data;
  }
  params?.snackbar.showMessage({
    type: 'error',
    data: <SnackbarApiErrorMessage errors={response?.errors} />,
  });
  return null;
};

const fetchPhones = async params => {
  const url = `${params?.fetchPhones}?limit=50`;
  const response = await params?.get(url);
  if (response?.ok) {
    return response?.data;
  }
  params?.snackbar.showMessage({
    type: 'error',
    data: <SnackbarApiErrorMessage errors={response?.errors} />,
  });
  return response;
};

const editEmail = async (params, email) => {
  const response = await params?.post(params?.editEmail, { email });
  return response;
};

const editPhones = async (params, phones) => {
  const phonesData = phones.map(item => {
    const { test, smsSubscriptionStatus, ...data } = item;
    return data;
  });
  const response = await params?.post(params?.editPhones, {
    phones: phonesData,
  });
  return response;
};

const saveEmail = async (params, data, defaultValues) => {
  let updatedPageData = { email: defaultValues.email || '' };
  let errors = [];
  const emailResponse = await editEmail(params, data.email);
  if (emailResponse?.ok) {
    const dataLength = emailResponse?.data?.data?.length;
    // For location setup, email is optional and can be removed
    if (dataLength >= 0) {
      updatedPageData = {
        ...updatedPageData,
        email: dataLength > 0 ? emailResponse?.data?.data[0]?.email : '',
      };
    }
  } else {
    errors = [...emailResponse.errors];
  }
  return { updatedPageData, errors };
};

const savePhones = async (params, data, defaultValues) => {
  let updatedPageData = { phones: defaultValues?.phones || [] };
  let errors = [];
  let warnings = [];
  if (data?.phones?.length > 0 || defaultValues?.phones?.length > 0) {
    const phonesResponse = await editPhones(params, data.phones);

    if (phonesResponse?.ok) {
      const phoneData = phonesResponse?.data?.data.map(item => {
        const { id, serviceProviderId: serviceProviderIdArg, ...other } = item;
        return other;
      });
      updatedPageData = {
        phones: phoneData,
      };
    } else {
      updatedPageData = {
        phones: data?.phones,
      };
      errors = [...phonesResponse.errors];
    }
    warnings = phonesResponse?.data?.warnings;
  }
  return { updatedPageData, errors, warnings };
};

export {
  fetchEmail,
  fetchPhones,
  savePhones,
  saveEmail,
  editPhones,
  editEmail,
};
